import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FilterActoCondicionModel } from 'src/app/models/acto-condicion/FilterActoCondicionModel';
import { CategoriaHipoModel } from 'src/app/models/categoria-hipo/CategoriaHipoModel';
import { FilterCategoriaHipoModel } from 'src/app/models/categoria-hipo/FilterCategoriaHipoModel';
import { FichaSsoModel } from 'src/app/models/ficha-sso/FichaSsoModel';
import { ResumenAccidentabilidadModel } from 'src/app/models/ficha-sso/ResumenAccidentabilidadModel';
import { FilterGbuModel } from 'src/app/models/gbu/FilterGbuModel';
import { GbuModel } from 'src/app/models/gbu/GbuModel';
import { IFilterActoCondicionModel } from 'src/app/models/interfaces/acto-condicion/IFilterActoCondicionModel';
import { ICategoriaHipoModel } from 'src/app/models/interfaces/categoria-hipo/ICategoriaHipoModel';
import { IFilterCategoriaHipoModel } from 'src/app/models/interfaces/categoria-hipo/IFilterCategoriaHipoModel';
import { IFilterGbuModel } from 'src/app/models/interfaces/gbus/IFilterGbuModel';
import { IGbuModel } from 'src/app/models/interfaces/gbus/IGbuModel';
import { IFilterProyectoModel } from 'src/app/models/interfaces/proyectos/IFilterProyectoModel';
import { IProyectoModel } from 'src/app/models/interfaces/proyectos/IProyectoModel';
import { IFilterTipoAccidenteModel } from 'src/app/models/interfaces/tipo-accidente/IFilterTipoAccidenteModel';
import { ITipoAccidenteModel } from 'src/app/models/interfaces/tipo-accidente/ITipoAccidenteModel';
import { IFilterTipoEmpleadoModel } from 'src/app/models/interfaces/tipo-empleado/IFilterTipoEmpleadoModel';
import { ITipoEmpleadoModel } from 'src/app/models/interfaces/tipo-empleado/ITipoEmpleadoModel';
import { IFilterTipoReglaModel } from 'src/app/models/interfaces/tipo-regla/IFilterTipoReglaModel';
import { ITipoReglaModel } from 'src/app/models/interfaces/tipo-regla/ITipoReglaModel';
import { FilterProyectoModel } from 'src/app/models/proyecto/FilterProyectoModel';
import { ProyectoModel } from 'src/app/models/proyecto/ProyectoModel';
import { FilterTipoAccidenteModel } from 'src/app/models/tipo-accidente/FilterTipoAccidenteModel';
import { TipoAccidenteModel } from 'src/app/models/tipo-accidente/TipoAccidenteModel';
import { FilterTipoEmpleadoModel } from 'src/app/models/tipo-empleado/FilterTipoEmpleadoModel';
import { TipoEmpleadoModel } from 'src/app/models/tipo-empleado/TipoEmpleadoModel';
import { FilterTipoReglaModel } from 'src/app/models/tipo-regla/FilterTipoReglaModel';
import { TipoReglaModel } from 'src/app/models/tipo-regla/TipoReglaModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CategoriaHipoService } from 'src/app/services/categoria-hipo/categoria-hipo.service';
import { GbuService } from 'src/app/services/Gbu/gbu.service';
import { ProyectoService } from 'src/app/services/proyecto/proyecto.service';
import { TipoAccidenteService } from 'src/app/services/tipo-accidente/tipo-accidente.service';
import { TipoEmpleadoService } from 'src/app/services/tipo-empleado/tipo-empleado.service';
import { TipoReglaService } from 'src/app/services/tipo-regla/tipo-regla.service';

@Component({
  templateUrl: './sso-engie-accidentabilidad-dialog.component.html',
  styleUrls: ['./sso-engie-accidentabilidad-dialog.component.css']
})
export class SsoEngieAccidentabilidadDialogComponent implements OnInit {
  listaCategorias: ICategoriaHipoModel[] = new Array<CategoriaHipoModel>();
  listaTipoRegla: ITipoReglaModel[]=new Array<TipoReglaModel>();
  listaTipoEmpleado: ITipoEmpleadoModel[]=new Array<TipoEmpleadoModel>();
  listaTipoAccidente: ITipoAccidenteModel[]=new Array<TipoAccidenteModel>();
  listaProyectos: IProyectoModel[]=new Array<ProyectoModel>();
  listaGbus: IGbuModel[]=new Array<GbuModel>();
  constructor(
    public dialogRef: MatDialogRef<SsoEngieAccidentabilidadDialogComponent>,
    private alertDialogService: AlertDialogService,
    private categoriaService: CategoriaHipoService,
    private tiporeglaService: TipoReglaService,
    private gbuService:GbuService,
    private proyectoService:ProyectoService,
    private tipoEmpleadoService:TipoEmpleadoService,
    private tipoAccidenteService: TipoAccidenteService,
    @Inject(MAT_DIALOG_DATA) public data: ResumenAccidentabilidadModel
    ) { }

  ngOnInit(): void {
      if(this.data.textoIdentificativo!=''){
        this.data.idGbuSelected = this.data.idGbu;
        this.data.idCategoriaHipoSelected = this.data.idCategoriaHipo;
        this.data.idTipoReglaSelected = this.data.idTipoRegla;
        this.data.idTipoEmpleadoSelected = this.data.idTipoEmpleado;
        if(this.data.tiempoPerdido)
          this.data.tiempoPerdidoSelected = 1;
        else
          this.data.tiempoPerdidoSelected = 0;
        this.data.idTipoAccidenteSelected = this.data.idTipoAccidente;
      }
    const filterGbu: IFilterGbuModel = new FilterGbuModel();
    this.gbuService
      .getAllList(filterGbu)
      .subscribe((data: IGbuModel[]) => {
        this.listaGbus = data;
      });

    const filterCategoria: IFilterCategoriaHipoModel = new FilterCategoriaHipoModel();
    this.categoriaService.getAllList(filterCategoria)
      .subscribe((data) => {
        this.listaCategorias = data;
      });
    
    const filterProyecto: IFilterProyectoModel = new FilterProyectoModel();
    this.proyectoService.getAllList(filterProyecto)
      .subscribe((data) => {
        this.listaProyectos = data;
      });

    const filterTipoRegla: IFilterTipoReglaModel = new FilterTipoReglaModel();
    this.tiporeglaService.getAllList(filterTipoRegla)
      .subscribe((data) => {
        this.listaTipoRegla = data;
      });
    
    const filterTipoEmpleado: IFilterTipoEmpleadoModel = new FilterTipoEmpleadoModel();
    this.tipoEmpleadoService.getAllList(filterTipoEmpleado)
      .subscribe((data) => {
        this.listaTipoEmpleado = data;
      });
    const filterTipoAccidente: IFilterTipoAccidenteModel = new FilterTipoAccidenteModel();
    this.tipoAccidenteService.getAllList(filterTipoAccidente)
      .subscribe((data) => {
        this.listaTipoAccidente = data;
      });
  }
  
  onNoClick(): void {
    this.dialogRef.close();
  }

  allowedChars:number[] = [37,39,46];

  check(event: KeyboardEvent, maxLength: number, value: any ) {
    if( event.keyCode > 31 && !this.allowedChars.includes(event.keyCode) && value && value.toString().length +1 >maxLength){
      event.preventDefault();
    }
  }
  
  onSubmit(form: NgForm) {
    
    if (!form.invalid) {      
      if (this.data.idGbuSelected)
        this.data.idGbu = this.data.idGbuSelected;
      if (this.data.idTipoReglaSelected)
        this.data.idTipoRegla = this.data.idTipoReglaSelected;
      //if (this.data.tiempoPerdidoSelected)
        this.data.tiempoPerdido = this.data.tiempoPerdidoSelected == 1;
      if (this.data.idCategoriaHipoSelected)
        this.data.idCategoriaHipo = this.data.idCategoriaHipoSelected;
      if (this.data.idTipoAccidenteSelected)
        this.data.idTipoAccidente = this.data.idTipoAccidenteSelected;
      if (this.data.idTipoEmpleadoSelected)
        this.data.idTipoEmpleado = this.data.idTipoEmpleadoSelected;
      
      let gbuSelected = this.listaGbus.find((p) => p.idGbu == this.data.idGbu);
      if(gbuSelected)
        this.data.gbu=gbuSelected.nombre;
      
      let categoriaSelected = this.listaCategorias.find((p) => p.idCategoriaHipo == this.data.idCategoriaHipo);
      if(categoriaSelected)
        this.data.categoriaHipo=categoriaSelected.nombre;

      let proyectoSelected = this.listaProyectos.find((p) => p.idProyecto == this.data.idProyecto);
      if(proyectoSelected)
        this.data.proyecto=proyectoSelected.nombre;

      let accidenteSelected = this.listaTipoAccidente.find((p) => p.idTipoAccidente == this.data.idTipoAccidente);
      if(accidenteSelected)
        this.data.tipoAccidente=accidenteSelected.nombre;
      
      let tipoempleoSelected = this.listaTipoEmpleado.find((p) => p.idTipoEmpleado == this.data.idTipoEmpleado);
      if(tipoempleoSelected)
        this.data.tipoEmpleado=tipoempleoSelected.nombre;
      
      let tiporeglaSelected = this.listaTipoRegla.find((p) => p.idTipoRegla == this.data.idTipoRegla);
      if(tiporeglaSelected)
        this.data.tipoRegla=tiporeglaSelected.nombre;
        
      this.dialogRef.close(this.data);
      
    }
  }
  
  public optionsSINO = [
    {"id": 1, "nombre": "SI"},
    {"id": 0, "nombre": "NO"}
  ]



}
